import isPreviewRoute from './isPreviewRoute';

/**
 * Checks if the current route is a preview route with a different user profile.
 * If so, attempts to switch to that profile and reloads the page to reinitialize ims.
 */
const switchProfileIfNeeded = async () => {
  try {
    const isPreview = isPreviewRoute();
    if (!isPreview) {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const targetUserId = searchParams.get('userId');
    if (!targetUserId) {
      return;
    }

    const { userId } = await window.adobeIMS.getProfile();
    if (userId === targetUserId) {
      return;
    }

    const newProfileData = await window.adobeIMS?.switchProfile(targetUserId);
    if (newProfileData?.profile) {
      window.location.reload();
    }
  } catch (error) {
    console.error('switchProfileIfNeeded:', error);
  }
};

export default switchProfileIfNeeded;
